<template>
  <div id="overview">
    <nav-list class="bg-default padded" id="nav-bar"/>
    <project-details class="project-details" v-if="!this.$route.params.projectblockid"></project-details>
    <project-block v-if="this.$route.params.projectblockid" class="project-block padded"></project-block>
    <project-block-details v-if="this.$route.params.projectblockid" class="project-block-details"></project-block-details>
  </div>
</template>

<script>
  import Loader from '../components/ui/Loader.vue'
  import { userService } from '../services/user.service.js';
  import NavList from '../components/lists/NavList.vue';
  import ProjectDetails from '../components/app/ProjectDetails.vue';
  import ProjectBlock from '../components/app/ProjectBlock.vue';
  import ProjectBlockDetails from '../components/app/ProjectBlockDetails.vue';

  export default {
    components: {
      NavList,
      ProjectDetails,
      ProjectBlock,
      ProjectBlockDetails,
      Loader
    },
    data () {
        return {
            token: JSON.parse(localStorage.getItem('user')).id
        }
    }
  }
</script>

<style lang="scss" scoped>
  #overview{
    display: flex;
    height: 100vh;
    width: 100vw;
  }

  #nav-bar{
    flex: 1;
    height: 100vh;
    overflow: auto;
  }

  .project-details{
    flex: 4;
  }

  .project-block{
    flex: 2;
    height: 100vh;
    overflow: auto;
  }

  .project-block-details{
    flex: 2;
    background: $bg-default;
  }

  @media #{$phone} {
    #overview{
      width: 200vw;
      height: 100vh;
      overflow: hidden;
    }

    #nav-bar{
      flex: .7;
    }

    .project-block{
      flex: 1.5;
    }

    .project-block-details{
      flex: 2;
    }
  }
</style>